import type { SegmentLockReason } from './clientApprovalPage.types';

export const LOCK_REASON_LABELS: Record<SegmentLockReason, string> = {
    dp: 'Validado pelo DP',
    client: 'Aceito por você',
};

export const LOCKED_FALLBACK_LABEL = 'Já definido';

export const SUBMIT_LABEL = 'Enviar Resposta';
export const SUBMITTING_LABEL = 'Enviando resposta...';
export const REJECTION_NOTE_LABEL = 'Motivo da recusa (obrigatório)';
export const REJECTION_NOTE_PLACEHOLDER = 'Explique por que está recusando este período...';
export const REJECTION_NOTE_MAX_LENGTH = 1000;

export const OPEN_PERIODS_TITLE = 'Responda só os períodos em aberto';
export const MULTIPLE_PERIODS_TITLE = 'Aceitar por período';
export const SINGLE_PERIOD_TITLE = 'Aceitar este período';

export const LOADING_LABEL = 'Carregando...';
export const LOAD_ERROR_TITLE = 'Erro';
export const LOAD_ERROR_MESSAGE = 'Ocorreu um erro ao processar sua solicitação. Tente novamente em alguns instantes.';

export const RESULT_COPY = {
    success: {
        title: 'Férias Confirmadas',
        message: 'A solicitação de férias foi confirmada com sucesso. Obrigado!',
    },
    correction_sent: {
        title: 'Resposta enviada',
        message: 'Você recusou ao menos um período. O colaborador vai ajustar as datas e você receberá um novo link para responder.',
    },
    already_rejected: {
        title: 'Resposta já enviada',
        message: 'Você já respondeu esta solicitação recusando ao menos um período. Aguarde o novo link após o ajuste do colaborador.',
    },
    invalid_segments: {
        title: 'A solicitação mudou',
        message: 'Os períodos foram alterados desde que você abriu o link. Recarregue a página para responder com os dados atuais.',
    },
    expired: {
        title: 'Link Expirado',
        message: 'O prazo para confirmar essa solicitação expirou (7 dias). Entre em contato para mais informações.',
    },
    closed: {
        title: 'Solicitação Encerrada',
        message: 'Esta solicitação não está mais aguardando confirmação do cliente.',
    },
    not_found: {
        title: 'Link Inválido',
        message: 'O link que você acessou não é válido.',
    },
} as const;

export const ALREADY_APPROVED_TITLE = 'Já Confirmado';
export const ALREADY_APPROVED_MESSAGE = 'Esta solicitação já foi confirmada';
